import { createElementBlock as o, openBlock as n, computed as c, createBlock as m, resolveDynamicComponent as f, mergeProps as y, createElementVNode as b, normalizeStyle as l, normalizeClass as d, Fragment as w, renderList as g, createCommentVNode as k, renderSlot as v } from "vue";
const h = (e, t) => {
  const r = e.__vccOpts || e;
  for (const [i, s] of t)
    r[i] = s;
  return r;
}, _ = {
  name: "YouTubeEmbed",
  props: {
    src: {
      type: String,
      required: !0
    },
    muted: {
      type: Boolean,
      default: !0
    },
    loop: {
      type: Boolean,
      default: !0
    },
    autoplay: {
      type: Boolean,
      default: !0
    },
    videoPlaying: {
      type: Boolean,
      default: !1
    }
  },
  emits: ["error", "durationchange", "ready", "play", "pause", "state-change", "ended", "timeupdate"],
  data() {
    return {
      player: null,
      network: "youtube",
      paused: !0,
      timerInterval: null
    };
  },
  computed: {
    duration() {
      var e;
      return (e = this.player) == null ? void 0 : e.getDuration();
    },
    currentTime: {
      get() {
        var e;
        return (e = this.player) == null ? void 0 : e.getCurrentTime();
      },
      set(e) {
        var t;
        (t = this.player) == null || t.seekTo(e);
      }
    }
  },
  watch: {
    videoPlaying(e) {
      e ? this.play() : this.pause();
    },
    muted(e) {
      e ? this.mute() : this.unmute();
    }
  },
  methods: {
    getDuration() {
      return this.duration;
    },
    startTimerInterval() {
      this.timerInterval && clearInterval(this.timerInterval), this.timerInterval = setInterval(() => {
        this.paused || this.$emit("timeupdate", { network: this.network, target: this.player });
      }, 250);
    },
    play() {
      var e;
      (e = this.player) == null || e.playVideo();
    },
    pause() {
      var e;
      (e = this.player) == null || e.pauseVideo();
    },
    whenPlay(e) {
      this.paused = !1, this.$emit("play", { network: this.network, target: e.target }), this.startTimerInterval();
    },
    whenPause(e) {
      this.paused = !0, this.$emit("pause", { network: this.network, target: e.target }), clearInterval(this.timerInterval);
    },
    mute() {
      var e;
      (e = this.player) == null || e.mute();
    },
    unmute() {
      var e;
      (e = this.player) == null || e.unMute();
    },
    initYouTube() {
      const e = this.src.split("v=").pop();
      this.player = new YT.Player("player", {
        videoId: e,
        playerVars: {
          autoplay: this.autoplay ? 1 : 0,
          loop: this.loop ? 1 : 0,
          controls: 0
        },
        events: {
          onReady: this.onYouTubePlayerReady,
          onStateChange: this.onYouTubePlayerStateChange
        }
      });
    },
    onYouTubePlayerReady(e) {
      this.$emit("ready", { network: this.network, target: e.target }), this.$emit("durationchange", { network: this.network, target: e.target }), e.target.seekTo(0), this.muted && !e.target.isMuted() ? e.target.mute() : !this.muted && e.target.isMuted() && e.target.unMute(), this.autoplay ? (e.target.playVideo(), this.paused = !1, this.startTimerInterval(), this.$emit("play", { network: this.network, target: e.target })) : (e.target.stopVideo(), this.paused = !0, this.$emit("pause", { network: this.network, target: e.target }));
    },
    onYouTubePlayerStateChange(e) {
      switch (this.$emit("state-change", { network: this.network, target: e.target }), e.data) {
        case YT.PlayerState.ENDED: {
          this.loop ? (e.target.seekTo(0), this.play()) : (clearInterval(this.timerInterval), this.$emit("ended", { network: this.network, target: e.target }));
          break;
        }
        case YT.PlayerState.PAUSED: {
          this.whenPause(e);
          break;
        }
        case YT.PlayerState.PLAYING: {
          this.whenPlay(e);
          break;
        }
      }
    }
  },
  mounted() {
    this.initYouTube();
  },
  beforeUnmount() {
    clearInterval(this.timerInterval);
  }
}, $ = { id: "player" };
function q(e, t, r, i, s, a) {
  return n(), o("div", $);
}
const I = /* @__PURE__ */ h(_, [["render", q], ["__scopeId", "data-v-f08e59af"]]);
function W(e, { baseUrl: t, urlParams: r, regex: i }) {
  let s = e.src.replace(i, t);
  if (r) {
    const a = new URLSearchParams(r), u = t.indexOf("?") >= 0 ? "&" : "?";
    s = s + u + a;
  }
  return s;
}
const p = {
  youtube: {
    // https://regex101.com/r/ssFKIf/1
    regex: /^((?:https?:)?\/\/)?((?:www|m)\.)?((?:youtube\.com|youtu.be))(\/(?:[\w\-]+\?v=|embed\/|v\/)?)([\w\-]+)(\S+)?$/i,
    baseUrl: "https://www.youtube.com/embed/$5",
    urlParams: {
      // DOCS: https://developers.google.com/youtube/player_parameters
      autoplay: 1,
      loop: 0,
      controls: 0,
      enablejsapi: 1,
      playsinline: 1,
      modestbranding: 1,
      showinfo: 0,
      rel: 0
    }
  },
  facebook: {
    // DOCS: https://developers.facebook.com/docs/plugins/embedded-video-player/#how-to-get-a-video-posts-url
    // https://regex101.com/r/wIHaK2/1
    // TODO: Facebook video URLs can come in more than one valid format. Currently this Regex only works for two of them.
    // We control that URL currently, so no big deal for now. However if we use this to embed from a user provided URL
    // we need to tweak the Regex to work for any valid video URL.
    regex: /^((?:https?:)?\/\/)?((?:www|m)\.)?((?:facebook\.com|facebook.co))(\/(?:[\w\-]+\?v=|facebook\/videos\/|v\/)?)([\w\-]+)(\S+)?$/i,
    baseUrl: "https://www.facebook.com/facebook/videos/$5"
  }
  // not required for graphic support currently, but leaving the code here for easily turning on support later.
  // vimeo: {
  //   regex: /^.*vimeo.com\/(\d+)($|\/|\b)/i,
  //   baseUrl: "https://player.vimeo.com/video/$1",
  //   urlParams: {
  //     title: 0,
  //     byline: 0,
  //     portrait: 0,
  //   },
  // },
  // dailymotion: {
  //   regex: /^.*(?:\/video|dai.ly)\/([A-Za-z0-9]+)([^#\&\?]*).*/i,
  //   baseUrl: "https://www.dailymotion.com/embed/video/$1",
  //   urlParams: {
  //     autoplay: 0,
  //   },
  // },
  // coub: {
  //   regex: /^.*coub.com\/(?:embed|view)\/([A-Za-z0-9]+)([^#\&\?]*).*/i,
  //   baseUrl: "https://coub.com/embed/$1",
  //   urlParams: {
  //     autoplay: 0,
  //   },
  // },
}, S = {
  name: "FacebookVideoEmbed",
  props: {
    src: {
      type: String,
      required: !0
    },
    muted: {
      type: Boolean,
      default: !0
    },
    loop: {
      type: Boolean,
      default: !0
    },
    autoplay: {
      type: Boolean,
      default: !0
    },
    videoPlaying: {
      type: Boolean,
      default: !1
    }
  },
  emits: [
    "error",
    "durationchange",
    "ready",
    "play",
    "pause",
    "timeupdate",
    "ended"
  ],
  data() {
    return {
      network: "facebook",
      paused: !0,
      fbVideoDiv: null,
      player: null,
      timerInterval: null
    };
  },
  computed: {
    finalSrc() {
      return p[this.network].regex.exec(this.src) ? W(this.$props, p[this.network]) : (this.$emit("error", { message: "Invalid or unsupported Facebook URL." }), null);
    },
    duration() {
      var e;
      return (e = this.player) != null && e.getDuration ? this.player.getDuration() : null;
    },
    currentTime: {
      get() {
        return this.player ? this.player.getCurrentPosition() : null;
      },
      set(e) {
        this.player && this.player.seek(e);
      }
    }
  },
  watch: {
    videoPlaying(e) {
      e ? this.play() : this.pause();
    },
    muted(e) {
      e ? this.mute() : this.unmute();
    },
    src(e) {
      e && (this.initFacebook(), this.facebookPlayerReady());
    }
  },
  mounted() {
    this.loadFacebookSDK(), this.observer = new MutationObserver(this.observerCallback), this.observer.observe(this.$refs.fbVideoDiv, { childList: !0 });
  },
  beforeUnmount() {
    this.observer.disconnect(), clearInterval(this.timerInterval);
  },
  methods: {
    getDuration() {
      return this.duration;
    },
    startTimerInterval() {
      this.timerInterval && clearInterval(this.timerInterval), this.timerInterval = setInterval(() => {
        this.player && !this.paused && this.$emit("timeupdate", { network: this.network, target: this.player });
      }, 250);
    },
    play() {
      this.player && (this.player.play(), this.startTimerInterval(), this.paused = !1, this.$emit("play", { network: this.network, target: this.player }));
    },
    pause() {
      this.player && (this.player.pause(), clearInterval(this.timerInterval), this.paused = !0, this.$emit("pause", { network: this.network, target: this.player }));
    },
    mute() {
      this.player && this.player.mute();
    },
    unmute() {
      this.player && this.player.unmute();
    },
    initFacebook() {
      window.FB.init({
        appId: "232298016899680",
        // TODO: figure out the best way to set this with ENV vars
        autoLogAppEvents: !0,
        xfbml: !0,
        version: "v2.9"
      });
    },
    facebookPlayerReady() {
      window.FB.Event.subscribe("xfbml.ready", (e) => {
        if (e.type === "video") {
          this.player = e.instance, console.log("Player ready:", this.player);
          const t = this.player;
          setTimeout(() => {
            this.$emit("ready", { network: this.network, target: t }), this.$emit("durationchange", { network: this.network, target: t });
          }, 100), this.autoplay ? (t.seek(0), t.play(), this.paused = !1, this.startTimerInterval(), this.$emit("play", { network: this.network, target: t })) : (t.pause(), t.seek(0), this.paused = !0, this.$emit("pause", { network: this.network, target: t })), this.muted ? this.mute() : this.unmute(), t.subscribe("paused", () => {
            this.paused = !0, this.$emit("pause", { network: this.network, target: t });
          }), t.subscribe("finishedPlaying", () => {
            this.loop ? this.play() : this.$emit("ended", { network: this.network, target: t });
          });
        }
      });
    },
    loadFacebookSDK() {
      if (window.FB)
        console.log("Facebook SDK already setup, so initializing player"), this.initFacebook(), this.facebookPlayerReady();
      else {
        console.log("Setting up Facebook SDK");
        const e = document.createElement("script");
        e.src = "https://connect.facebook.net/en_US/sdk.js", e.async = !0, e.defer = !0, e.crossOrigin = "anonymous", e.nonce = "3wT0LBAQ", document.head.appendChild(e), window.fbAsyncInit = () => {
          this.initFacebook(), this.facebookPlayerReady();
        };
      }
    },
    observerCallback(e) {
      for (const t of e)
        t.type === "childList" && this.$refs.fbVideoDiv.querySelector("iframe").classList.add(
          "tgb-iframe",
          "tgb-iframe--video-embed",
          "tgb-iframe--facebook"
        );
    }
  }
}, D = ["data-href"];
function P(e, t, r, i, s, a) {
  return n(), o("div", {
    ref: "fbVideoDiv",
    class: "fb-video",
    "data-href": a.finalSrc,
    "data-autoplay": "true",
    "data-allow": "autoplay; clipboard-write; encrypted-media; picture-in-picture",
    "data-width": "auto"
  }, null, 8, D);
}
const T = /* @__PURE__ */ h(S, [["render", P], ["__scopeId", "data-v-4e1ab756"]]), E = {
  __name: "VideoEmbed",
  props: {
    network: {
      type: String,
      required: !0
    }
  },
  setup(e) {
    const t = e, r = c(() => ({
      youtube: I,
      facebook: T
    })[t.network] || null);
    return (i, s) => (n(), m(f(r.value)));
  }
}, C = {
  name: "Marquee",
  props: {
    paused: {
      type: Boolean,
      default: !1
    },
    reverse: {
      type: Boolean,
      default: !1
    },
    animate: {
      type: Boolean,
      default: !0
    },
    itemGap: {
      type: String,
      default: "0px"
    },
    animationIterationCount: {
      type: String,
      default: "infinite"
    },
    spaceBetween: {
      type: Number,
      required: !1,
      default: null
    },
    speed: {
      type: [String, Number],
      default: "normal",
      validator: (e) => ["fast", "normal", "slow"].includes(e) || typeof e == "number" && e > 500 && e < 4e3
    }
  },
  data() {
    return {
      marqueeDiv: null,
      marqueeWidthWrapper: null,
      contentWidth: 0,
      marqueeWidth: 0,
      marqueeWidthWrapperObserver: null,
      marqueeObserver: null
    };
  },
  computed: {
    spaceBetweenStyle() {
      return this.spaceBetween ? {
        width: `${this.spaceBetween}px`
      } : {};
    },
    crawlSpeedMilliseconds() {
      return isNaN(this.speed) ? this.speed === "fast" ? 1e3 : this.speed === "slow" ? 3e3 : 2e3 : this.speed;
    },
    computedWidth() {
      return this.contentWidth + 1e5;
    },
    smallContent() {
      return this.contentWidth < this.marqueeWidth;
    },
    offSetForDivDraw() {
      return this.marqueeWidth === 0 || this.contentWidth === 0 || !this.animate ? 0 : this.smallContent ? this.contentWidth * 4 : 0;
    },
    repeat() {
      return this.animate ? this.spaceBetween || this.marqueeWidth === 0 || this.contentWidth === 0 ? 2 : this.smallContent ? Math.floor((this.marqueeWidth + this.contentWidth) / this.contentWidth) + 4 : 2 : 1;
    },
    duration() {
      return this.marqueeWidth === 0 || this.contentWidth === 0 ? 10 : this.contentWidth * this.crawlSpeedMilliseconds / 100 / 1e3;
    },
    marqueeStyle() {
      return {
        animationDuration: `${this.duration}s`,
        animationDirection: this.reverse ? "reverse" : "normal",
        animationIterationCount: this.animationIterationCount,
        gap: this.itemGap
      };
    }
  },
  methods: {
    onContentChange() {
      this.contentWidth = this.$refs.marqueeWidthWrapper.firstElementChild.offsetWidth || 0;
    },
    onMarqueeWidthChange() {
      this.marqueeWidth = this.$refs.marqueeDiv.offsetWidth;
    },
    debounce(e, t) {
      let r;
      return (...i) => {
        r !== null && clearTimeout(r), r = setTimeout(() => {
          e(...i);
        }, t);
      };
    }
  },
  mounted() {
    this.marqueeWidthWrapperObserver = new ResizeObserver(this.debounce(this.onContentChange, 100)), this.marqueeObserver = new ResizeObserver(this.debounce(this.onMarqueeWidthChange, 100)), this.marqueeWidthWrapperObserver.observe(this.$refs.marqueeWidthWrapper.firstElementChild), this.marqueeObserver.observe(this.$refs.marqueeDiv);
  },
  beforeUnmount() {
    this.marqueeWidthWrapperObserver.disconnect(), this.marqueeObserver.disconnect();
  }
};
function B(e, t, r, i, s, a) {
  return n(), o("div", y({ class: "tgb-marquee" }, e.$attrs, { ref: "marqueeDiv" }), [
    b("div", {
      ref: "marqueeWidthWrapper",
      class: d(["tgb-marquee__width-wrapper", {
        "tgb-marquee__paused": r.paused
      }]),
      style: l({ width: a.computedWidth + "px", marginLeft: -a.offSetForDivDraw + "px" })
    }, [
      (n(!0), o(w, null, g(a.repeat, (u) => (n(), o("div", {
        key: u,
        class: d([
          r.animate ? "tgb-marquee__content--animation" : "",
          "tgb-marquee__content-repeater"
        ]),
        style: l(a.marqueeStyle)
      }, [
        r.animate ? (n(), o("div", {
          key: 0,
          style: l(a.spaceBetweenStyle)
        }, null, 4)) : k("", !0),
        v(e.$slots, "default", {}, void 0, !0)
      ], 6))), 128))
    ], 6)
  ], 16);
}
const F = /* @__PURE__ */ h(C, [["render", B], ["__scopeId", "data-v-e91d786b"]]);
export {
  T as FacebookVideoEmbed,
  F as Marquee,
  E as VideoEmbed,
  I as YouTubeEmbed
};
